import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"
import { extractFirstLetters } from "../../../../utils/ExtractFirstLetters"

const SyllabusCard = ({ data }) => {
  return (
    <div className="flex items-center justify-between p-4 hover:bg-gray-50">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-medium">
          {extractFirstLetters(data?.name)}
        </div>
        <div>
          <h3 className="font-medium mb-1">
            {data?.name}
          </h3>
          <p className="text-xs text-gray-500 mb-0">
            {data?.description?.length > 50 ? (
              `${data?.description?.slice(0, 50)}...`
            ) : (
              data?.description
            )}
          </p>
        </div>
      </div>
      <Link to={`/app/exam-syllabus/${data?.id}`}>
        <button className="bg-gray-200 hover:bg-gray-300 duration-200 p-3 rounded-full">
          <ChevronRight className="h-5 w-5 text-gray-400" />
        </button>
      </Link>
    </div>
  )
}

export default SyllabusCard
